<template>
	<ProcessCreatePage>
		<Header :title="$t('generate_form_client').toString()">
			<p>
				{{ $t('required_data_red_stars') }}
			</p>
		</Header>
		<div class="main">
			<BaseSelect
				class="w-2/5"
				ref="BaseSelect"
				required="true"
				:label="$t('client')"
				@input="prefill($event)"
				:options="clientOptions"
				v-model="selectedClient"
				:allow-empty="false"
			/>
			<div v-if="evaluateState">
				<CustomerForm ref="PersonNameForm" v-model="model" @updateValue="model = $event" :disabled="false" :show-company="true" />
			</div>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick()"
			@skipButtonClick="continueButtonClick(true)"
			:is-back-button="false"
			:is-skippable="false"
		/>
	</ProcessCreatePage>
</template>

<script>
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import Validate from '@/mixins/Validate';
import CustomerForm from '@/components/forms/CustomerForm.vue';

export default {
	name: 'Client',
	components: { CustomerForm, BaseSelect, ProcessCreatePage, Header, Footer },
	mixins: [Validate],
	props: {
		startValue: {},
		hideBackBtn: { type: Boolean, default: false },
	},
	data() {
		return {
			clientOptions: [],
			selectedClient: null,
			model: {
				city: {
					zipCode: '',
					name: null,
				},
				damageAssessor: {
					id: null,
				},
				_shadow: {
					damageAssessor: {
						id: null,
					},
				},
			},
			damageAssessorExtern: false,
		};
	},
	computed: {
		evaluateState() {
			if (this.selectedClient === null) {
				return false;
			} else return this.selectedClient.value === 'other';
		},
	},
	methods: {
		prefill($event) {
			this.selectedClient = $event;
			if ($event) {
				this.model = {
					id: this.selectedClient.id,
					firstName: this.selectedClient.firstName,
					lastName: this.selectedClient.lastName,
				};
			} else {
				this.model = {};
			}

			if (this.customSelected) {
				this.validIgnored = [];
			}
		},
		continueButtonClick: function() {
			if (this.validate()) {
				if (this.selectedClient) {
					let client = this.model;
					client.id = this.selectedClient === this.clientOptions[0] ? this.startValue.id : null;
					if (this.selectedClient === this.clientOptions[0]) {
						client = null;
					}
					this.$emit('next', { client: client });
				} else {
					this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
				}
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
	watch: {
		startValue: function() {
			if (this.clientOptions.length === 0) {
				const clientName =
					this.startValue.gender === 'company' ? this.startValue.company.name : this.startValue.firstName + ' ' + this.startValue.lastName;
				this.clientOptions.push({
					display: clientName,
					value: 'customer',
				});
				this.clientOptions.push({
					display: this.$t('other_client'),
					value: 'other',
					class: 'italic',
				});

				this.selectedClient = this.clientOptions[0];
			}
		},
	},
};
</script>

<style scoped></style>
